import React from "react";
import { Button, Input, Upload, DatePicker, Empty, Modal, InputNumber, Checkbox } from "antd";

import { makeStyles, withStyles } from "@material-ui/core/styles";
import { Switch } from "@material-ui/core";
import LinearProgress from "@material-ui/core/LinearProgress";

import { LoadingOutlined, CloseOutlined, FormOutlined, PlusOutlined } from "@ant-design/icons";
import Spinner from "./../assets/Spinner.gif";
import InputMask from './InputMask';

const { confirm } = Modal;
const { Search } = Input;

const useStylesPg = makeStyles(theme => ({
  root: {
    width: "100%",
    "& > * + *": {
      marginTop: theme.spacing(2),
    },
  },
}));

const ColorLinearProgress = withStyles({
  colorPrimary: {
    backgroundColor: "#f2bd68",
  },
  barColorPrimary: {
    backgroundColor: "#e5f0fb",
  },
})(LinearProgress);

export function InputPadrao(props) {
  const innerProps = {};
  if (!!props.tabIndex) {
    innerProps["tabindex"] = props.tabIndex;
  }

  const keyPress = e => {
    if (e.keyCode === 13) {
      if (!!props.tabIndex) {
        const inx = parseInt(props.tabIndex);
        const els = document.querySelectorAll(`[tabindex="${inx + 1}"]`);
        const el = els.length ? els[0] : document.querySelectorAll(`[tabindex="0"]`)[0];

        el.focus();
      }
    }
  };

  if (!!props.mask) {
    return <InputMask mask={props.mask} onKeyDown={keyPress} {...innerProps} {...props} />;
  }

  return <Input onKeyDown={keyPress} {...innerProps} {...props} />;
}
export function InputNumberPadrao(props) {
  return <InputNumber {...props} />;
}

export function SearchInputPadrao(props) {
  return <Search {...props} enterButton />;
}

export function InputUploadPadrao(props) {
  return <Upload {...props}>{props.children}</Upload>;
}

export function DatePickerPadrao(props) {
  return <DatePicker format={props.picker === "month" ? "MM/YYYY" : "DD/MM/YYYY"} {...props} />;
}

export function BtnPadrao(props) {
  return <Button {...props}>{props.children}</Button>;
}

export function BtnAdd(props) {
  return (
    <Button
      shape="circle"
      type="primary"
      {...props}
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        boxShadow: "0px 0px 10px #bfbfbf",
        ...props.style,
      }}
    ></Button>
  );
}

export function BtnEdit(props) {
  return <FormOutlined className="cor-primary cad-icon" {...props} style={{ ...props.style }} />;
}

export function ModalConfirmPadrao(title, content, okText, cancelText, onOk, onCancel) {
  function modalDelete() {
    confirm({
      title,
      content,
      okText,
      cancelText,
      onOk,
      onCancel: onCancel,
    });
  }

  return modalDelete();
}

export function BtnDeletar(props) {
  function modalDelete() {
    confirm({
      title: "Deseja deletar o registro?",
      content: "Uma vez deletado não podera ser recuperado!",
      okText: "Sim",
      cancelText: "Cancelar",
      onOk() {
        props.onOk();
      },
    });
  }

  return (
    <>
      {props.withLabel ? (
        <BtnPadrao
          {...props}
          fontSize="1.175em"
          onClick={() => {
            if (props.disableModal) {
              props.onClick();
              return;
            } else {
              modalDelete();
            }
          }}
        >
          {props.withLabel}
        </BtnPadrao>
      ) : (
        <CloseOutlined
          {...props}
          className="cor-danger cad-icon"
          onClick={() => {
            if (props.disableModal) {
              props.onClick();
              return;
            } else {
              modalDelete();
            }
          }}
        />
      )}
    </>
  );
}

export function ProgressBarPadrao(props) {
  const classes = useStylesPg();

  return (
    <div className={classes.root}>
      <ColorLinearProgress />
    </div>
  );
}

export function SemDados({ text, ...props }) {
  return (
    <div
      {...props}
      style={{
        textAlign: "center",
        ...props.style,
      }}
    >
      <Empty description={text ? text : "Sem dados"} />
    </div>
  );
}

export function ModalPadrao(props) {
  return (
    <Modal style={{ marginTop: -50 }} {...props}>
      {props.children}
    </Modal>
  );
}

export function LabelPadrao(props) {
  return (
    <label
      {...props}
      style={{
        fontWeight: "bold",
        marginTop: !props.noMargin && 15,
        display: "block",
        ...props.style,
      }}
    >
      {props.children}
    </label>
  );
}

export function SwitchBicolorPadrao(props) {
  const ModifiedSwitch = withStyles({
    switchBase: {
      color: "rgb(220, 0, 78)",
    },
    track: {
      backgroundColor: "rgb(220, 0, 78)",
    },
  })(Switch);

  return <ModifiedSwitch color="primary" {...props} />;
}

export function CheckBoxPadrao(props) {
  return <Checkbox {...props}>{props.children}</Checkbox>;
}

export function CardPadrao(props) {
  return (
    <div {...props} style={{ display: "flex", boxShadow: "0 0 10px #ddd", borderTopRightRadius: 10, borderBottomRightRadius: 10, ...props.style }}>
      <div style={{ width: 15, height: "100%", background: props.color }} />
      <div
        style={{
          width: "100%",
          height: "100%",
          textAlign: "center",
          position: "relative",
        }}
      >
        <LabelPadrao>{props.title}</LabelPadrao>
        <h2 style={{ color: props.color }}>{props.value}</h2>
      </div>
    </div>
  );
}

export function LoadingContainerPadrao({ loading, transparent, ...props }) {
  return (
    <div style={{ position: "relative" }}>
      <div style={{ opacity: loading ? (transparent ? 0.5 : 0) : 1 }}>{props.children}</div>
      <div style={{ position: "absolute", width: "100%", height: "100%", textAlign: "center", top: "0", padding: 25, display: loading ? "block" : "none" }}>
        {!props.disableSpinner && (
          <div style={{ top: "45%", left: "50%", transform: "translate(-50%, -50%)", position: "absolute", textAlign: "center" }}>
            <img src={Spinner} alt="spinner" style={{ fontSize: 25, color: "#1976d2", ...props.spinnerProps }} />
          </div>
        )}
      </div>
    </div>
  );
}

export function BtnIncluir(props) {
  return (
    <BtnPadrao {...props}>
      <PlusOutlined /> Incluir
    </BtnPadrao>
  );
}
